import { Package } from "lucide-react";
import { DELIVERY_TYPE_DESC } from "@/lib/format";

// Shared is a future private-driver service, not the internal fleet offer.
// Preserve the existing variants and do not infer environmental savings.
export default function SharedSustainabilityBadge({ variant = "soft", className = "" }) {
  if (variant === "inline") {
    return (
      <span
        data-testid="shared-sustainability-badge-inline"
        className={`inline-flex items-center gap-1.5 rounded-full bg-dapnow-blue-soft text-dapnow-blue px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wider ${className}`}
      >
        <Package className="size-3" /> Shared · In arrivo
      </span>
    );
  }

  const dark = variant === "dark";
  return (
    <div
      data-testid={dark ? "shared-sustainability-badge-dark" : "shared-sustainability-badge"}
      className={`rounded-2xl p-3.5 flex gap-3 ${dark ? "bg-white/10 ring-1 ring-white/20" : "border border-dapnow-line bg-dapnow-blue-soft"} ${className}`}
    >
      <span className={`inline-flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl ${dark ? "bg-white/10 text-white" : "bg-white text-dapnow-blue"}`}>
        <Package className="size-4" />
      </span>
      <div className="text-left min-w-0">
        <p className={`text-[11px] uppercase tracking-wider font-bold ${dark ? "text-white" : "text-dapnow-blue"}`}>
          Shared · In arrivo
        </p>
        <p className={`text-xs mt-0.5 leading-snug ${dark ? "text-white/90" : "text-dapnow-ink"}`}>
          {DELIVERY_TYPE_DESC.shared}.
        </p>
        <a href="/become-driver" className={`inline-block mt-2 text-xs font-semibold underline ${dark ? "text-white" : "text-dapnow-blue"}`}>Richiedi informazioni</a>
      </div>
    </div>
  );
}
